<div>
    <div class="d-flex header">
        <div class="title">
            <h1>{{ publication.title }}</h1>
        </div>
        <div class="d-flex chef" *ngIf="publication.chef; else chefIA">
            <img class="avatar" src="{{ publication.chef.mainImageUrl }}" alt="ChefPhoto" />
            <span>{{ publication.chef.firstName }}</span>
        </div>
        <ng-template #chefIA>
            <div class="d-flex chef">
                <img class="avatar" src="assets/images/chefi.svg" alt="ChefIAPhoto" />
                <span>Chefi</span>
            </div>
        </ng-template>

    </div>

    <div class="container containerCarousel text-center">
        <div id="carouselExampleIndicators" class="carousel slide" data-bs-touch="true">
            <div class="carousel-inner">
                <div class="carousel-indicators carousel-control">
                    <button *ngFor="let slide of publication.images; let i = index" id="slide{{i}}" type="button" data-bs-target="#carouselExampleIndicators" [attr.data-bs-slide-to]="i" [class.active]="i === 0" [attr.aria-current]="i === 0 ? 'true' : null" [attr.aria-label]="'Slide ' + (i + 1)"></button>
                </div>
                <div *ngFor="let img of publication.images; let i = index" class="carousel-item" [class.active]="i === 0">
                    <img [src]="img.url" class="d-block w-100" alt="Slide {{ i + 1 }}" />
                </div>
            </div>
        </div>
    </div>

    <div class="container text-desc">
        <div class="mb-2">
            <span>{{ publication.content }}</span>
        </div>
        <div class="d-flex align-items-center">
            <img src="assets/images/icon-shape.svg" />
            <span class="m-2 font-weight-bold">A {{ publication.likeCount }} personas les ha gustado
      </span>
        </div>
    </div>
    <div class="chat-container d-flex flex-column flex-1">
        <div class="chat-bubble">
            <img src="assets/images/chefi.svg" alt="Chefi avatar" class="avatar" />
            <div class="bubble-text">
                Hola soy Chefi, estoy aquí para ayudarte a cocinar {{publication.title}}
            </div>
        </div>
        <div class="chat-bubble" *ngFor="let step of publication.recipe?.steps?.slice(0,2); let isLast = last">
            <img src="assets/images/chefi.svg" alt="Chefi avatar" class="avatar" />
            <div class="d-flex flex-column">
                <div class="div-desc mb-2">
                    <div class="bubble-text">
                        {{!isLast ? 'Excelente receta, vamos con el primer' : 'Vamos a continuar, a por el siguiente'}} paso: {{step.title}}
                    </div>
                </div>
                <div class="div-desc">
                    <div class="bubble-text" [class.faded-div]="isLast" [innerHTML]="step.description">

                    </div>
                    <div class="container-download" *ngIf="isLast">
                        <button class="btn"><img src="assets/images/arrow-dwn.svg" />Descargar app
                    </button>

                        <div class="more-info">
                            ¿Quieres seguir leyendo? <br /> Descarga nuestra aplicación para acceder a esta y muchas más recetas.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>